module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Regular.3f978ac.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/PorscheNextWCy-Regular.woff
// module id = Xhyz
// module chunks = 5